import React from 'react';
import PropTypes from 'prop-types';
import {Box, List, ListItem, Typography} from '@mui/material';
import {toBlocks, toBoldParts} from './replyBlocks';

const Line = ({text}) => (
    <>
        {toBoldParts(text).map((part, index) =>
            part.bold
                ? <strong key={index}>{part.text}</strong>
                : <React.Fragment key={index}>{part.text}</React.Fragment>
        )}
    </>
);

Line.propTypes = {text: PropTypes.string};

const FelicityReply = ({text}) => (
    <Box sx={{display: 'flex', flexDirection: 'column', gap: 1}}>
        {toBlocks(text).map((block, index) => {
            if (block.kind === 'text') {
                return (
                    <Typography key={index} variant="body2" sx={{lineHeight: 1.6}}>
                        <Line text={block.lines.join(' ')}/>
                    </Typography>
                );
            }

            return (
                <List
                    key={index}
                    sx={{
                        listStyleType: block.kind === 'steps' ? 'decimal' : 'disc',
                        pl: 3,
                        py: 0,
                        '& .MuiListItem-root': {display: 'list-item', px: 0, py: 0.25}
                    }}
                >
                    {block.lines.map((line, at) => (
                        <ListItem key={at}>
                            <Typography variant="body2" sx={{lineHeight: 1.6}}>
                                <Line text={line}/>
                            </Typography>
                        </ListItem>
                    ))}
                </List>
            );
        })}
    </Box>
);

FelicityReply.propTypes = {text: PropTypes.string};

export default FelicityReply;
